module.exports = __webpack_public_path__ + "img/mutiblack.7f2959b3.png";